import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { LoaderService } from "./loader.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { GeneralModalService } from "./general-modal.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";

declare var $: any;

@Injectable({
  providedIn: "root",
})
export class LoaderInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private loaderService: LoaderService,
    private modalService: GeneralModalService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.showLoader();

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.sessionCheck(event);
            this.onEnd();
          }
        },
        (err: any) => {
          this.onEnd();
        }
      )
    );
  }

  sessionCheck(response: any) {
    if (response.status === 200) {
      if (!(response.body instanceof Blob)) {
        try {
          if (response.body && response.body.alert.code === 401) {
            this.authService.logout();
            this.router.navigate(["/home"]);
            // this.router.navigate(["/home"], {
            //   queryParams: { session: AppConstants.SessionExpired },
            // });
          }

          if (response.body && response.body.alert.code === 417) {
            this.authService.getGTStatus((resp) => {
              if (resp.alert.code == 200) {
                $('#alert-top-message').html(response.body.alert.message);
                $('#alert-top-modal').modal('show');
                localStorage.setItem('topStatus', resp.data.isPBD2);
                localStorage.setItem('gtStatus', resp.data.isGeneralTrade);
              }
            }, () => {
              localStorage.clear();
              this.router.navigate(['/']);
            });
          }
        } catch {
          if (response.body.code === 401) {
            this.authService.logout();
            this.router.navigate(["/home"]);
            // this.router.navigate(["/home"], {
            //   queryParams: { session: AppConstants.SessionExpired },
            // });
          }
        }
      }
    }
  }

  private showModal(err: any) {
    if (err instanceof HttpErrorResponse) {
      this.modalService.show(err.statusText);
    }
  }

  private onEnd(): void {
    this.hideLoader();
  }

  private showLoader(): void {
    this.loaderService.show();
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }
}
